/**
 * Pair.tsx — k/v 详情块两件套
 *
 * 移植自原型 design/Novel-admin/src/primitives.jsx 的 Pair / Row。
 * Pair：两行 k/v；upper 走 dialogs2 的大写字距小标题样式。
 * Row：单行 k/v（左标签固定宽 + 右值），dialogs/dialogs2/users 的横排 k-v。
 * JSX/className/inline-style 与蓝本 1:1。
 */

import type { CSSProperties, ReactNode } from 'react';

export function Pair({
  k,
  v,
  mono,
  upper,
}: {
  k: ReactNode;
  v: ReactNode;
  mono?: boolean;
  upper?: boolean;
}) {
  const labelStyle: CSSProperties = upper
    ? {
        fontSize: 10.5,
        color: 'var(--fg-faint)',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
      }
    : { fontSize: 11, color: 'var(--fg-muted)', marginBottom: 3 };
  const valueStyle: CSSProperties = upper
    ? { fontSize: 12.5, marginTop: 2 }
    : { fontSize: 12.5, fontWeight: 500 };
  return (
    <div>
      <div style={labelStyle}>{k}</div>
      <div className={mono ? 'mono' : ''} style={valueStyle}>
        {v}
      </div>
    </div>
  );
}

export function Row({
  k,
  v,
  mono,
  last,
  kWidth = 80,
}: {
  k: ReactNode;
  v: ReactNode;
  mono?: boolean;
  last?: boolean;
  kWidth?: number;
}) {
  return (
    <div
      className="hstack"
      style={{
        padding: '6px 0',
        borderBottom: last ? 0 : '1px dashed var(--border)',
        gap: 12,
      }}
    >
      <span style={{ fontSize: 11.5, color: 'var(--fg-muted)', width: kWidth, flexShrink: 0 }}>
        {k}
      </span>
      <span className={mono ? 'mono' : ''} style={{ fontSize: 12, flex: 1 }}>
        {v}
      </span>
    </div>
  );
}
